module.exports = __webpack_public_path__ + "img/banner.ffdf4fa7.webp";